var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMxn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3276)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8125 0H23V23H15.8125V0Z",
    fill: "#D9071E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H8.625V23H0V0Z",
    fill: "#006923"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 0H15.8125V23H7.1875V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3386 7.5835C10.3386 7.5835 9.84496 8.09396 9.93727 8.63818C10.0296 9.1824 11.0024 8.63818 10.8848 8.11084C10.7672 7.5835 10.3386 7.5835 10.3386 7.5835Z",
    fill: "#FCCA3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58481 8.8822C9.21547 8.8822 9.06148 8.47181 9.13788 8.03562C9.17871 7.80251 9.28475 7.50679 9.45778 7.12256L10.074 7.61587C10.008 7.76237 9.95543 7.88953 9.91643 7.99449C10.0456 8.04538 10.173 8.12096 10.2766 8.21196C10.6122 8.50662 10.7357 9.03164 10.376 9.42074C10.3063 9.49605 10.1933 9.75279 10.131 9.99936C10.3026 10.0121 10.4253 10.0466 10.5384 10.1358C10.8561 10.3863 10.8262 10.8433 10.5843 11.1961C10.4128 11.4462 10.1839 11.6491 9.96821 11.753C9.60937 11.9259 9.22544 11.8597 9.22544 11.2472L9.22535 11.2427C9.22465 11.2178 9.22344 11.1751 9.38369 11.1703C9.11026 11.1651 9.05174 10.9721 9.01763 10.6284C9.009 10.5414 9.00551 10.4585 9.00071 10.2797V10.2797L9.00071 10.2797C8.99766 10.1638 8.99766 10.1638 8.99367 10.05V10.05L8.99252 10.0248C8.98711 9.9142 8.98337 9.8376 9.16937 9.8376H8.75244V8.87926H9.16937C9.40583 8.87926 9.53651 8.98573 9.6114 9.20585C9.65308 9.10604 9.69843 9.01205 9.74616 8.92781C9.68604 8.90006 9.62507 8.8822 9.58481 8.8822ZM10.0426 10.5655L10.0538 10.5495C10.0526 10.5513 10.0514 10.5536 10.0502 10.5563L10.0426 10.5655ZM9.72877 10.8496C9.72797 10.8499 9.72756 10.85 9.72772 10.8499L9.72892 10.8496L9.72877 10.8496ZM9.73579 10.8478C9.73298 10.8484 9.73038 10.8492 9.72892 10.8496L9.73579 10.8478ZM9.7287 10.4884L9.73018 10.5027C9.72935 10.4944 9.72858 10.4853 9.72784 10.475L9.7287 10.4884ZM9.3837 11.1703C9.386 11.1702 9.38834 11.1702 9.39071 11.1701L9.3837 11.1703ZM9.41491 11.1698C9.40648 11.1698 9.39842 11.1699 9.39071 11.1701L9.40398 11.1697L9.41491 11.1698Z",
    fill: "#A8AC71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8478 11.8862C13.8478 11.8862 14.5127 9.25904 13.4558 7.89913C12.399 6.53922 11.1778 6.63022 11.1778 6.63022C11.1778 6.63022 10.8261 6.97861 11.1778 7.24432C11.5294 7.51003 11.3821 7.76479 11.3821 7.76479C11.3821 7.76479 10.7931 6.96742 10.4021 7.43327C10.0112 7.89913 10.7671 7.82823 10.6871 8.179C10.6071 8.52977 10.268 10.0871 10.7634 10.8734C11.2589 11.6596 10.295 11.489 10.4911 11.489C10.6871 11.489 11.3821 11.672 11.3821 11.489C11.3821 11.306 11.6237 12.2005 11.8305 12.2005C12.0373 12.2005 12.1969 11.8862 12.1969 11.8862C12.1969 11.8862 12.4867 12.2005 12.6633 12.2005C12.84 12.2005 13.4558 11.9948 13.4558 11.9948L12.2918 10.6871C12.2918 10.6871 12.362 10.1103 12.1969 9.98551C12.0317 9.86067 13.5206 11.0918 13.6372 11.489C13.7538 11.8862 13.8478 11.8862 13.8478 11.8862Z",
    fill: "#8F4620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95404 11.2378C7.95404 11.2378 8.06196 10.7792 8.1775 10.7474C8.27761 10.7198 8.4881 10.9672 8.4881 10.9672C8.86202 13.7366 9.76616 14.8183 11.2664 14.8183C12.7842 14.8183 13.7042 13.9964 14.241 11.4422C14.241 11.4422 14.5264 11.0536 14.6271 11.0968C14.7367 11.1438 14.8741 11.6579 14.8741 11.6579C14.7367 14.6447 13.1195 16.4151 11.2912 16.4151C9.44535 16.4151 7.93819 14.4314 7.95404 11.2378Z",
    fill: "#9FAB2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58398 13.0874C9.58398 13.0874 11.7434 13.6982 12.5957 13.6982C13.448 13.6982 11.8479 14.6257 11.2235 14.6257C10.5991 14.6257 9.58398 13.0874 9.58398 13.0874Z",
    fill: "#2FC2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5417,
    y: 13.5127,
    width: 1.4375,
    height: 1.02679,
    rx: 0.0833333,
    fill: "#F9AA51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75116 11.6305L9.33954 11.0801C10.1053 12.5354 11.2505 13.0142 12.8522 12.5145L13.016 13.4476C11.1436 14.0318 9.69631 13.4267 8.75116 11.6305Z",
    fill: "#259485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9251 11.8359C11.9251 11.8359 11.0527 12.4482 11.3435 12.4482C11.6343 12.4482 12.7723 12.7543 12.5508 12.4482C12.3294 12.1421 11.9251 11.8359 11.9251 11.8359Z",
    fill: "#FCCA3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8937 11.1056C10.8937 11.1056 10.7279 10.4673 10.383 10.4673C10.0381 10.4673 10.1355 10.9909 9.96958 10.9909C9.80371 10.9909 10.1241 11.3594 10.2669 11.3594C10.4098 11.3594 10.8937 11.1056 10.8937 11.1056Z",
    fill: "#FCCA3D"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3276)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3276",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxn);
export default __webpack_public_path__ + "static/media/MXN.b68713767313e52d769a0100e61f5634.svg";
export { ForwardRef as ReactComponent };